import { sizeLimitMb } from '_common/components/upload/commonUtil';
import { translate as t } from '_common/utils/language';

const accept = 'image/jpeg,image/jpg,image/png,application/pdf';

function getFormSource() {
  return {
    13: {
      id: '13',
      title: t('edd.personal.tax'),
      subTitle: t('edd.personal.tax'),
      descList: [
        t('edd.personal.taxTips1'),
        t('edd.personal.taxTips2'),
        t('edd.personal.taxTips3'),
      ],
      uploadList: [
        {
          id: 1, // 唯一标志
          fileId: '', // 上传之后的图片的Id
          type: 13, // 文件的类型
          exampleHref: '',
          exampleText: '',
          uploadText: '',
          uploadHref: '',
          accept,
          sizeLimit: sizeLimitMb(),
        },
      ],
      checkInfo: {
        checked: false,
        text: t('edd.personal.taxCheck'),
      },
    },
    14: {
      id: '14',
      title: t('edd.personal.wages'),
      subTitle: t('edd.personal.wages.subTitle'),
      descList: [
        t('edd.personal.wagesTips1'),
        t('edd.personal.wagesTips2'),
        t('edd.personal.wagesTips3'),
      ],
      uploadList: [
        {
          id: 1,
          fileId: '', // 上传之后的图片的Id
          type: 14,
          exampleHref: '',
          exampleText: '',
          uploadText: '',
          uploadHref: '',
          accept,
          sizeLimit: sizeLimitMb(),
        },
        {
          id: 2,
          fileId: '', // 上传之后的图片的Id
          type: 15,
          exampleHref: '',
          exampleText: '',
          uploadText: '',
          accept,
          sizeLimit: sizeLimitMb(),
        },
      ],
      checkInfo: {
        checked: false,
        text: t('edd.personal.wagesCheck'),
      },
    },
    15: {
      id: '15',
      title: t('edd.personal.declare'),
      subTitle: t('edd.personal.declare'),
      descList: [
        t('edd.personal.declareTips1'),
        t('edd.personal.declareTips2'),
        t('edd.personal.declareTips3'),
      ],
      uploadList: [
        {
          id: 1,
          fileId: '', // 上传之后的图片的Id
          type: 16,
          exampleHref:
            'https://s3-ap-northeast-1.amazonaws.com/okcoin-jp-public/public/kyc-example/tax/tax.zip',
          exampleText: '',
          uploadText: '',
          uploadHref: '',
          accept,
          sizeLimit: sizeLimitMb(),
        },
      ],
      checkInfo: {
        checked: false,
        text: t('edd.personal.declareCheck'),
      },
    },
    16: {
      id: '16',
      title: t('edd.personal.bank'),
      subTitle: t('edd.personal.bank'),
      descList: [
        t('edd.personal.bankTips1'),
        t('edd.personal.bankTips2'),
        t('edd.personal.bankTips3'),
      ],
      uploadList: [
        {
          id: 1,
          fileId: '', // 上传之后的图片的Id
          type: 17,
          exampleHref: '',
          exampleText: '',
          uploadText: '',
          uploadHref: '',
          accept,
          sizeLimit: sizeLimitMb(),
        },
      ],
      checkInfo: {
        checked: false,
        text: t('edd.personal.bankCheck'),
      },
    },
    17: {
      id: '17',
      title: t('edd.personal.security'),
      subTitle: t('edd.personal.security'),
      descList: [
        t('edd.personal.securityTips1'),
        t('edd.personal.securityTips2'),
        t('edd.personal.securityTips3'),
      ],
      uploadList: [
        {
          id: 1,
          fileId: '', // 上传之后的图片的Id
          type: 18,
          exampleHref: '',
          exampleText: '',
          uploadText: '',
          uploadHref: '',
          accept,
          sizeLimit: sizeLimitMb(),
        },
      ],
      checkInfo: {
        checked: false,
        text: t('edd.personal.securityCheck'),
      },
    },
    18: {
      id: '18',
      title: t('edd.personal.other'),
      subTitle: t('edd.personal.other'),
      descList: [
        t('edd.personal.otherTips1'),
        t('edd.personal.otherTips2'),
        t('edd.personal.otherTips3'),
      ],
      uploadList: [
        {
          id: 1,
          fileId: '', // 上传之后的图片的Id
          type: 19,
          exampleHref: '',
          exampleText: '',
          uploadText: '',
          uploadHref: '',
          accept,
          sizeLimit: sizeLimitMb(),
        },
      ],
      checkInfo: {
        checked: false,
        text: t('edd.personal.otherCheck'),
      },
    },
  };
}

export default getFormSource;
